import React from "react";

interface PaginationItemProps extends React.HTMLAttributes<HTMLButtonElement>{
  active?: string | undefined
  disabled?: string | undefined
  name?: string | undefined
}

interface PaginationItemState {
  isHover: boolean
  backgroundColor: string
  color: string
}

class PaginationItem extends React.Component<PaginationItemProps, PaginationItemState> {

  state = {
    isHover: false,
    backgroundColor: (this.props.disabled === 'true') ? "#F6F6F8" : (this.props.active)? "#002E6D" : "#FFF",
    color: (this.props.disabled === 'true') ? "#C5C6C5" : (this.props.active)? "#FFF" : "#0061A0"
  }

  handleMouseHover = (isDisabled: string | undefined, isActive: string | undefined,  isHover: boolean) => {
    let newBackground = (this.props.disabled === 'true') ? "#F6F6F8" : (this.props.active)? "#002E6D" : "#FFF";
    if (isHover){
      newBackground = (this.props.disabled === 'true') ? "#F6F6F8" : (this.props.active)? "#000E4D" : "#CCC";
    } 

    this.setState({ backgroundColor: newBackground});
    
  }

  componentDidUpdate(prevProps: Readonly<PaginationItemProps>, prevState: Readonly<PaginationItemState>, snapshot?: any): void {
    if (prevProps.active !== this.props.active){
      let newBackground = (this.props.disabled === 'true') ? "#F6F6F8" : (this.props.active)? "#002E6D" : "#FFF";
      let newColor = (this.props.disabled === 'true') ? "#C5C6C5" : (this.props.active)? "#FFF" : "#0061A0"
      this.setState({ backgroundColor: newBackground, color: newColor});
    }
  }

  render() {
    const buttonStyle:React.CSSProperties = {
      display: "flex",
      width: "48px",
      height: "48px",
      padding: "2px 24px",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",      
      backgroundColor: this.state.backgroundColor,
      border: (this.props.active === 'true') ? "1px solid #002E6D" : "1px solid #C5C6C5",
      color: (this.props.disabled === 'true') ? "#C5C6C5" : (this.props.active)? "#FFF" : "#0061A0",
      fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on",
      fontFamily: "FS Elliot Pro Regular",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "28px",      
      borderRadius: (this.props.name === "fly-first") ? "4px 0px 0px 4px" : ((this.props.name === "fly-last"))? "0px 4px 4px 0px" : "",
      cursor:"pointer"
    }

    return (     
      <button
        className={this.props.className}
        name={this.props.name}
        style={buttonStyle}        
        onClick={this.props.onClick}
        onMouseEnter={() => this.handleMouseHover(this.props.disabled, this.props.active, true)}
        onMouseLeave={() => this.handleMouseHover(this.props.disabled, this.props.active, false)}
      >
        {this.props.children}
      </button>     
    );
  }
}

export default PaginationItem;